import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";

// Only the authenticated portal/admin areas may show this modal.
const isPortalRoute = (pathname) => /^\/(portal|admin)(\/|$)/.test(pathname || "");

const SessionExpiredModal = () => {
  const { isAuthenticated, isSessionExpiredModalOpen, sessionExpiredCode, closeSessionExpiredModal, logout } = useAuth();
  const { t } = useTranslation("portal");
  const navigate = useNavigate();
  const location = useLocation();

  const bodyKey =
    sessionExpiredCode === "INVALID_TOKEN"
      ? "sessionExpiredModal.bodyInvalid"
      : "sessionExpiredModal.bodyExpired";

  // Never show on public pages (landing, login, signup, marketing, etc.) —
  // only inside the authenticated portal/admin areas, and only for a real session.
  if (!isAuthenticated || !isPortalRoute(location.pathname)) return null;

  return (
    <Modal
      isOpen={Boolean(isSessionExpiredModalOpen)}
      onClose={() => {}}
      isCentered
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("sessionExpiredModal.title")}</ModalHeader>
        <ModalBody>
          <Text>{t(bodyKey)}</Text>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="teal"
            size="sm"
            onClick={() => {
              closeSessionExpiredModal();
              logout();
              navigate("/login");
            }}
          >
            {t("sessionExpiredModal.action")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SessionExpiredModal;
